import React from 'react';

export function FileUploadButton({ id, multiple, accept, onChange, label, className }) {
  return (
    <div className="relative">
      <input
        type="file"
        id={id}
        multiple={multiple}
        accept={accept}
        onChange={onChange}
        className="hidden"
      />
      <label
        htmlFor={id}
        className={`inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer ${className}`}
      >
        {label}
      </label>
    </div>
  );
} 